import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentEditingGroupId = createSelector([selectAssortmentState], (state) => {
  return state.editingGroupId
})
